import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowUp, MessageCircle } from "lucide-react";
import { SITE } from "../../config/site";

export const FloatingActions = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 700);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const toTop = () => {
    if (window.__lenis) window.__lenis.scrollTo(0, { duration: 1.4 });
    else window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="fixed bottom-24 right-7 z-40 flex flex-col items-end gap-3">
      {SITE.whatsapp && (
        <a
          href={`https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent("Hi RCS, I'd like to discuss a project.")}`}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="whatsapp-float-button"
          aria-label="Chat on WhatsApp"
          className="flex h-12 w-12 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition-transform duration-300 hover:scale-110"
        >
          <MessageCircle className="h-5 w-5" />
        </a>
      )}
      <AnimatePresence>
        {show && (
          <motion.button
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 12 }}
            onClick={toTop}
            data-testid="back-to-top-button"
            aria-label="Back to top"
            className="flex h-12 w-12 items-center justify-center rounded-full bg-navy text-gold-light shadow-lg ring-1 ring-gold/30 transition-colors duration-300 hover:bg-gold hover:text-navy"
          >
            <ArrowUp className="h-5 w-5" />
          </motion.button>
        )}
      </AnimatePresence>
    </div>
  );
};
